import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <rect width="22" height="22" x="1" y="1" fill="#9DB149" rx="11"></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16.667 8.5l-6.417 6.417L7.333 12"
      ></path>
      <rect
        width="22"
        height="22"
        x="1"
        y="1"
        stroke="#9DB149"
        strokeWidth="2"
        rx="11"
      ></rect>
    </svg>
  );
}

export default Icon;
